module.exports = __webpack_public_path__ + "img/roedkaal.71466600.jpg";